import React from "react";
import { motion } from "framer-motion";
import { Reveal, stagger, fadeUp } from "./Reveal";
import { Heart, ArrowUpRight } from "lucide-react";
import { COUPLES } from "../data/site";

export const CouplesTherapy = ({ onBook }) => (
  <section id="couples" className="py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 items-start">
      <div className="lg:col-span-5 lg:sticky lg:top-28">
        <Reveal><span className="overline">For couples</span></Reveal>
        <Reveal delay={0.05}>
          <h2 className="section-title text-3xl sm:text-4xl lg:text-5xl mt-4 leading-tight text-[#20301A]">
            Rebuild how you <em className="italic text-[#3A7D32]">connect</em>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-5 text-[#55703F] leading-relaxed max-w-md">{COUPLES.intro}</p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-6 flex flex-wrap gap-2">
            {COUPLES.modalities.map((m) => (
              <span key={m} data-testid={`couples-modality-${m}`} className="rounded-full bg-[#FFEFDF] border border-[#FFC9A0] px-3.5 py-1.5 text-xs text-[#20301A]">{m}</span>
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <button data-testid="couples-book-btn" onClick={onBook}
            className="group mt-8 inline-flex items-center gap-2 rounded-full bg-[#3A7D32] text-[#F2F8E8] px-6 py-3 text-sm hover:bg-[#20301A] transition-all">
            Book couples consultation <ArrowUpRight size={16} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </button>
        </Reveal>
      </div>

      <div className="lg:col-span-7">
        <Reveal delay={0.08}>
          <div className="overline mb-4">Common relationship concerns we work with</div>
        </Reveal>
        <motion.div variants={stagger} initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-60px" }}
          className="grid sm:grid-cols-2 gap-4">
          {COUPLES.problems.map((prob) => (
            <motion.div key={prob} variants={fadeUp} data-testid={`couples-problem-${prob}`}
              className="flex items-start gap-3 rounded-2xl bg-[#DFF0C4]/60 border border-[#C9DFAC] p-5">
              <span className="grid place-items-center w-8 h-8 rounded-full bg-[#FFC9A0] text-[#3A7D32] shrink-0"><Heart size={15} /></span>
              <p className="text-sm text-[#3C5A2E] leading-relaxed">{prob}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  </section>
);
